export default __webpack_public_path__ + "static/media/confetti.892a8671.png";